<template>
  <div class="mobileweb-promo-setting">
    <div class="promo-design-group">
      <div style="margin-bottom: 16px">
        <v-textarea
          v-model.trim="
            (currentTranslations.hasOwnProperty('rf_mobile_title') ? previewActions : actions)
              .rf_mobile_title
          "
          variant="outlined"
          :rows="2"
          label="Title"
          :disabled="currentTranslations.hasOwnProperty('rf_mobile_title')"
          name="title"
          hideDetails
        ></v-textarea>
        <RfInsertUserTrait
          v-if="!currentTranslations.hasOwnProperty('rf_mobile_title')"
          :app="app"
          actionName="rf_mobile_title"
          title="title"
          :actions="actions"
        />
      </div>
      <div class="div-flex-layout" style="margin-bottom: 22px">
        <v-text-field
          v-model.trim="actions.rf_settings_mobile_title_font_size"
          variant="outlined"
          density="compact"
          persistentPlaceholder
          hideDetails
          label="Title Font Size"
          name="title-font-size"
          required
        ></v-text-field>
        <v-text-field
          v-model.trim="actions.rf_settings_mobile_message_font_size"
          variant="outlined"
          density="compact"
          persistentPlaceholder
          hideDetails
          label="Message Font Size"
          name="message-font-size"
          required
        ></v-text-field>
      </div>
      <div style="margin-bottom: 16px">
        <v-textarea
          v-model.trim="
            (currentTranslations.hasOwnProperty('rf_mobile_message') ? previewActions : actions)
              .rf_mobile_message
          "
          variant="outlined"
          :rows="model.path_type === 'retention_modal' ? 4 : 3"
          label="Message"
          :disabled="currentTranslations.hasOwnProperty('rf_mobile_message')"
          name="message"
          hideDetails
        ></v-textarea>
        <RfInsertUserTrait
          v-if="!currentTranslations.hasOwnProperty('rf_mobile_message')"
          :app="app"
          actionName="rf_mobile_message"
          title="message"
          :actions="actions"
        />
      </div>
      <div
        v-if="model.path_type !== 'widget'"
        class="div-flex-layout"
        :style="model.path_type === 'video' ? {} : { marginBottom: '22px' }"
      >
        <v-text-field
          v-if="model.path_type !== 'text'"
          v-model.trim="actions.rf_settings_mobile_title_padding_top"
          variant="outlined"
          density="compact"
          persistentPlaceholder
          hideDetails
          label="Message Top Padding"
          name="hero-unit-height"
        ></v-text-field>
      </div>
    </div>
    <div v-if="backgroundImageEnabled && model.path_type !== 'video'" style="padding-top: 10px">
      <h4>Background</h4>
      <RfRetentionImageUpload isMobile :actions="actions" :model="model" />
    </div>
  </div>
</template>
<script>
import UploadImageMixin from "@/utils/UploadImageMixin";
import RfInsertUserTrait from "@/components/RfPathCreate/RfRetentionActions/RfInsertUserTrait.vue";
import LanguagePreviewMixin from "@/utils/LanguagePreviewMixin";
import RfRetentionImageUpload from "./components/RfRetentionImageUpload.vue";

export default {
  name: "RfRetentionActionsMobileWeb",
  components: { RfInsertUserTrait, RfRetentionImageUpload },
  mixins: [UploadImageMixin, LanguagePreviewMixin],
  props: ["actions", "model", "app"],
  computed: {
    backgroundImageEnabled() {
      if (!this.model.id) return true;
      if (this.actions.rf_settings_bg_image) return true;
      return Object.hasOwn(this.currentTranslations, "rf_settings_bg_image");
    },
  },
};
</script>
